import moment from 'moment';
import { SupportTypeDto } from './supportTypeDto';

export class SupportDto {
  public id: number;
  public beginDate: Date;
  public endDate: Date;
  public supportType: SupportTypeDto;
  public beneficiaryId: number;
  public typeSupportDetail?: string;
  public historized: boolean;

  public static fromJson(json: any): SupportDto {
    if (json) {
      return {
        id: json.id,
        beginDate: json.beginDate ? moment(json.beginDate).toDate() : undefined,
        endDate: json.endDate ? moment(json.endDate).toDate() : undefined,
        supportType: SupportTypeDto.fromJson(json.supportType),
        typeSupportDetail: json.typeSupportDetail,
        beneficiaryId: json.beneficiaryId,
        historized: json.historized,
      } as SupportDto;
    }
  }
}
